import React, { useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import {
  Form,
  Button,
  Row,
  Col,
  Input,
  message,
  Popconfirm,
  Switch
} from 'antd'
import {
  UPDATE_PRODUCT_VARIANTS,
  SOFT_DELETE_PRODUCT_VARIANT
} from '../ProductQueries'
import { ProductVariant } from '@slerp/controls'
import { Store } from 'antd/lib/form/interface'
const { useForm } = Form

interface ProductVarianFormProps {
  setShow: (value: boolean) => void
  record: ProductVariant
  refetchProducts: () => void
}

const ProductVariantForm = (props: ProductVarianFormProps) => {
  const { setShow, record, refetchProducts } = props
  const [form] = useForm()
  const [published, setPublished] = useState(false)
  const [alcoholic, setAlcoholic] = useState(false)

  useEffect(() => {
    setPublished(record.published)
    setAlcoholic(record.restrictions && record.restrictions.alcoholic)
    form.resetFields()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])

  const [updateProductVariants] = useMutation(UPDATE_PRODUCT_VARIANTS)
  const [softDeleteProductVariant] = useMutation(SOFT_DELETE_PRODUCT_VARIANT)

  const onFinish = (values: Store) => {
    const { name, sku, price, vat, limit } = values
    if (form.validateFields()) {
      message.loading('Updating variant... Please Wait.')

      updateProductVariants({
        variables: {
          name: name,
          id: record.key,
          sku: sku,
          price: parseFloat(price),
          vat: parseFloat(vat),
          limit: parseFloat(limit),
          published: published,
          restrictions: {
            id: record.restrictions.id,
            alcoholic: alcoholic
          }
        }
      }).then((result) => {
        message.destroy()
        refetchProducts()
        message.success('Variant updated!', 1)
        setShow(false)
        form.resetFields()
      })
    }
  }

  const onDelete = () => {
    message.loading('Deleting variant...')

    softDeleteProductVariant({
      variables: { id: record.key }
    }).then((result) => {
      message.destroy()
      refetchProducts()
      message.success('Variant deleted', 1)
      setShow(false)
    })
  }

  return (
    <>
      <Form form={form} initialValues={record} onFinish={onFinish}>
        <label>Name</label>
        <Form.Item name='name'>
          <Input placeholder='Enter name' size='large' />
        </Form.Item>
        <label>SKU</label>
        <Form.Item name='sku'>
          <Input placeholder='Enter SKU' size='large' />
        </Form.Item>

        <Row>
          <Col>
            <label>Price</label>
            <Form.Item name='price'>
              <Input
                placeholder='Enter price'
                required
                type='number'
                size='large'
                min='0.0'
                step='0.01'
              />
            </Form.Item>
          </Col>
          <Col offset={2}>
            <label>VAT</label>
            <Form.Item name='vat'>
              <Input
                placeholder='Enter VAT'
                required
                type='number'
                size='large'
                min='0.0'
                step='0.01'
              />
            </Form.Item>
          </Col>
        </Row>

        <label>Order Limit</label>
        <Form.Item name='limit'>
          <Input
            placeholder='Enter order limit'
            required
            type='number'
            size='large'
            min='0'
            step='1'
          />
        </Form.Item>

        <Row style={{ margin: '24px 0' }}>
          <Switch
            title='Age Verification'
            checked={alcoholic}
            onChange={setAlcoholic}
          />
          <label style={{ marginLeft: '8px' }}>Age Verification</label>
        </Row>

        <Row style={{ marginBottom: '24px' }}>
          <Switch
            title='Published'
            checked={published}
            onChange={setPublished}
          />
          <label style={{ marginLeft: '8px' }}>Published</label>
        </Row>

        <hr
          style={{
            borderColor: '#e8e8e8',
            borderStyle: 'none none solid',
            margin: '24px 0',
            width: '100%'
          }}
        />

        <Row justify='space-between'>
          <Col>
            <Popconfirm
              title='Are you sure to delete this variant?'
              onConfirm={onDelete}
              okText='Confirm'
              cancelText='Cancel'
            >
              <Button type='text' danger>
                Delete
              </Button>
            </Popconfirm>
          </Col>
          <Col>
            <Button
              type='text'
              onClick={() => {
                setShow(false)
              }}
            >
              Cancel
            </Button>
            <Button type='primary' htmlType='submit'>
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default ProductVariantForm
